<template>
    <span>
    <button @click="openModal" :class="buttonClass"
            :disabled="!question.explanation">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        <slot></slot>
    </button>


        <!-- explanation modal -->
    <div class="modal fade" :id="question.explanationId" v-if="showModal"
         tabindex="-1" role="explanation" aria-hidden="true" style="display: none;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <a href="javascript:;" data-dismiss="modal" aria-hidden="true" style="float: right; color: rgb(176, 184, 192);">
                        <i class="fa  fa-times" aria-hidden="true"></i>
                    </a>
                    <h4 class="modal-title">
                        Επεξήγηση Eρώτησης
                    </h4>
                </div>
                <div class="modal-body">
                    <div class="m-heading-1 border-blue m-bordered">
                        <p>{{ question.explanation }} </p>
                    </div>
                    <div class="explanation-wrapper">

                        <video :src="question.explanation_video" loop muted autoplay
                               v-if="question.explanation_video && question.explanation_video.length > question.explanation_img.length"
                               class="explanation-image">
                        </video>

                        <img class="explanation-image"
                             :src="question.explanation_img"
                             alt=""
                             v-else>
                    </div>
                </div>
                <div class="modal-footer">
                    <a class="btn btn-circle default btn-sm" data-dismiss="modal">Κλείσιμο</a>
                </div>
            </div>
        </div>
    </div>
    </span>
</template>

<script>
    import {bus} from '../../packs/application';

    export default {
        data() {
            return {
                showModal: false
            };
        },
        props:   ['question', 'buttonClass'],
        methods: {
            openModal() {
                if (!this.question.explanation) return;
                this.showModal = true;
                this.$nextTick(function () {
                    $("#" + this.question.explanationId).modal();
                });
            }
        },
        watch:   {
            question() {
                this.showModal = false;
            }
        },
        mounted() {
            bus.$on('openModal', this.openModal);
        }
    };
</script>